"use client";

import type { LogoConfig } from "./LogoSlider";

const DEFAULT_HEIGHT = 32;

export function LogoGrid({
  logos,
  height = DEFAULT_HEIGHT,
  maxCount,
}: {
  logos: LogoConfig[];
  height?: number;
  maxCount?: number;
}) {
  const displayLogos = maxCount ? logos.filter((_, i) => i < maxCount) : logos;
  return (
    <ul role='list' className='tw-grid tw-grid-cols-3 tw-gap-x-5 tw-gap-y-8 tw-items-center'>
      {displayLogos.map((logo, index) => {
        const width = (logo.width / logo.height) * height;
        return (
          <li key={index} className='tw-flex tw-items-center tw-justify-center'>
            <div
              className='tw-bg-white/80'
              style={{
                height,
                width,
                mask: `url(${logo.src}) center / contain no-repeat`,
                WebkitMask: `url(${logo.src}) center / contain no-repeat`,
              }}
              role='img'
              aria-label={logo.alt}
            />
          </li>
        );
      })}
    </ul>
  );
}
